import { SupportedLanguages } from '@/models/localization.model';
import { useTranslation } from 'react-i18next';

interface IUseLocale {
  isNorwegian: boolean;
  currentLocale: SupportedLanguages;
}

const useLocale = (): IUseLocale => {
  const { i18n } = useTranslation();
  const currentLocale = i18n.language as SupportedLanguages;
  const isNorwegian = currentLocale === SupportedLanguages.NO;

  return { isNorwegian, currentLocale };
};

export default useLocale;
